export const ORDER_INITIAL_VALUES = {
	full_name: '',
	phone: '',
	email: '',
	message: '',
	address: '',
};
